import { useEffect, useState } from "react";
import FaqComponent from "../../FaqComponent/FaqComponent";
import FileInput from "../../avatar-generator/FileInput/FileInput";
import MainBlock from "../../avatar-generator/MainBlock/MainBlock";
import ExampleSlider from "../../extend_image/ExampleSlider/ExampleSlider";
import TutorialBlock from "../../remove_video_bg/UploadFileLanding/TutorialBlock/TutorialBlock";
import ExamplesScroll from "../ExamplesScroll/ExampleScroll";
import { mainBlockData, scrollData, sliderData } from "../constants";
import { useStore } from "../../../stores/use_global_state";
import { uploadMlFile } from "../../../pages/api/apiMl";
import { gaCreditsLimit } from "../../../utils/gaCreditsLimit.js";
import TryOurTools from "../../tryOurTools/tryOurTools.jsx";
import UploadYourFile from "../../tryAITool/tryAITool.jsx";
import ExamplesWrapper from "../../examples/examplesWrapper/examplesWrapper.jsx";
import { VinteoBannerBig } from "../../vinteo/vinteoBanner.js";

function InteriorLayout({ dictionary, uploadFile, isLoading, checkNonAuth }) {
	const [loadingState, setLoadingState] = useState(isLoading);
	const { state, dispatch } = useStore();

	useEffect(() => {
		setLoadingState(isLoading);
	}, [isLoading]);

	const textData = { title: dictionary["page_interior_h6"], videoUrl: "/interior_design/tutorial/interior_tutorial.mp4", posterUrl: "/interior_design/tutorial/tutorial_preview.jpg" };

	const tutorialData = [
		{ title: dictionary["upload"] || "Upload", description: dictionary["page_interior_upload_desc"] },
		{ title: dictionary["page_interior_redesign"], description: dictionary["page_interior_redesign_desc"] },
		{ title: dictionary["download"] || "Download", description: dictionary["page_interior_download_desc"] },
	];

	const clickHandler = async (file) => {
		if (checkNonAuth()) return;
		let access = document.getElementById("top");
		access.scrollIntoView({ behavior: "smooth" }, true);

		setLoadingState(true);

		if (state.isAuth) {
			if (state?.accountData?.plan === "free" && state?.accountData?.total_credits < 1) {
				gaCreditsLimit("INTERIOR");
				dispatch({ type: "setVideoError", error_msg: "free_limit_img", error_code: "free_limit_img" });
				setLoadingState(false);
				return false;
			}

			if ((state?.accountData?.plan === "pro" || state?.accountData?.plan === "promo") && state?.accountData?.total_credits < 1) {
				gaCreditsLimit("INTERIOR");
				dispatch({ type: "setVideoError", error_msg: "pro_limit", error_code: "pro_limit" });
				setLoadingState(false);
				return false;
			}
		}
		let token = state?.userInfo?.token ? state.userInfo.token : false;
		fetch(file)
			.then((res) => res.blob())
			.then(async (blob) => {
				let imgFile = new File([blob], "img.png", { type: blob.type });
				const { data } = await uploadMlFile(imgFile, token);
				dispatch({ type: "setInteriorRedesignImg", imageData: { image: data.file_url, id: data.id } });
				setLoadingState(false);
				setTimeout(() => {
					window.scrollTo(0, 0);
				}, 100);
			});
	};

	return (
		<>
			<MainBlock dictionary={dictionary} uploadFile={uploadFile} isLoading={loadingState} mainBlockData={mainBlockData}>
				<FileInput dictionary={dictionary} uploadFile={uploadFile} isLoading={loadingState} creditCost={"1_credit"} checkNonAuth={checkNonAuth} />
			</MainBlock>
			<ExamplesWrapper type="interior" t={dictionary} />
			<ExamplesScroll dictionary={dictionary} scrollData={scrollData} />
			<ExampleSlider dictionary={dictionary} sliderData={sliderData} isSliderLeft={true} isBlurBack={true} />
			<TutorialBlock tutorialData={tutorialData} textData={textData} />
			<UploadYourFile dictionary={dictionary} />
			<FaqComponent dictionary={dictionary} pageName={"page_interior"} />
			<TryOurTools t={dictionary} />
			<VinteoBannerBig />
		</>
	);
}

export default InteriorLayout;
